var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45365 11.6696C7.2679 11.4653 7.28296 11.149 7.48729 10.9633L12.397 6.49991L1.02362 6.49991C0.747482 6.49991 0.523624 6.27606 0.523624 5.99991C0.523624 5.72377 0.747482 5.49991 1.02362 5.49991L12.397 5.49991L7.48729 1.03655C7.28296 0.850797 7.2679 0.534573 7.45365 0.330244C7.63941 0.125915 7.95563 0.110857 8.15996 0.29661L14.4336 5.99992L8.15996 11.7032C7.95563 11.889 7.63941 11.8739 7.45365 11.6696Z",
    fill: "#1D1D46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.c30d8d32f4d7929cda414dfa152564f9.svg";
export { ForwardRef as ReactComponent };